var footer = {    
    home:"Home",
    registerbooking:"Register a Booking",
    track:"Track and Redeem",
    details:"Details and FAQs",
    followUs:"Follow us",
    privacyPolicy:"Privacy Notice",
    cookiePolicy:"Cookie Policy",
}
module.exports = footer


